export const getCookieDomain = (env: string) => {
    if (env === 'test') {
        return 'test.jucy.com';
    }
    if (env === 'prod') {
        return 'jucy.com';
    }
    return undefined;
};
